import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTING_CAMBIO_VIA_PAGO_PENSION, URL_CERTIFICADOS } from '@constants/url.constant';

@Component({
    selector: 'app-calendario-pago-pension-home',
    templateUrl: './calendario-pago-pension-home.component.html',
    styleUrls: ['./calendario-pago-pension-home.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CalendarioPagoPensionHomeComponent {

  calendario: any[] = [];

  constructor(
    private readonly router: Router,
  ) {
    this.calendario = [
      { mes: 'Agosto 2024', apellidoAL: 'Viernes 16', apellidoMZ: 'Lunes 19' },
      {
        mes: 'Septiembre 2024',
        apellidoAL: 'Lunes 16',
        apellidoMZ: 'Martes 17',
      },
      {
        mes: 'Octubre 2024',
        apellidoAL: 'Miércoles 16',
        apellidoMZ: 'Jueves 17',
      },
      {
        mes: 'Noviembre 2024',
        apellidoAL: 'Viernes 15',
        apellidoMZ: 'Lunes 18',
      },
      {
        mes: 'Diciembre 2024',
        apellidoAL: 'Lunes 16',
        apellidoMZ: 'Martes 17',
      },
    ];
  }

  irCambioViaPago() {
    this.router.navigate([ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_BASE,
      ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_URL,
      ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_HOME]);
  }

  irCertificados(){
    this.router.navigate([URL_CERTIFICADOS]);
  }
}
